<template>
  <v-layout row wrap>
    <v-flex xs12>
      <h2>{{ metadata.mainText }}</h2>

      <!-- Only show crosswalk if it exists -->
      <v-card v-if="hasCrossWalk" :elevation="1" class="crosswalk">
        <ul class="crosswalks">
          <li v-for="item in crossWalk" :key="item">
            {{ item }}
          </li>
        </ul>
      </v-card>

      <p class="margined" v-if="metadata.htmlSubText" v-html="metadata.htmlSubText"></p>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'QuestionText',

  props: {
    metadata: Object
  },

  data () {
    return {
      crossWalk: null
    };
  },

  async mounted () {
    await this.loadCrossWalk();
  },

  methods: {
    /**
     * Loads and parses metadata.crossWalk safely.
     * Async so it can be extended later (e.g., remote fetch).
     */
    async loadCrossWalk () {
      if (!this.metadata || !this.metadata.crossWalk) {
        this.crossWalk = null;
        return;
      }

      try {
        const parsed = JSON.parse(this.metadata.crossWalk);

        if (Array.isArray(parsed)) {
          this.crossWalk = parsed;
        } else if (typeof parsed === 'string') {
          this.crossWalk = [parsed];
        } else {
          this.crossWalk = null;
        }
      } catch (err) {
        this.crossWalk = null;
      }
    }
  },

  computed: {
    hasCrossWalk () {
      return Array.isArray(this.crossWalk) && this.crossWalk.length > 0;
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 19pt;
}

h2 {
  font-size: 17pt;
  margin-top: 5px;
  font-weight: bold;
  max-width: 1000px;
}

.margined {
  margin: 16px;
  max-width: 1000px;
}

ul.margined {
  margin: 15px 35px;
}

ul.margined > li {
  margin: 10px 0;
}

.bolded {
  font-weight: bold;
}

.v-card.crosswalk {
  background-color: #e8edf8;
  border: 1px solid #d6deed;
  margin: 10px 15px;
  padding: 10px;
  max-width: 1000px;
}

.crosswalks {
  margin-bottom: 0px;
}
</style>
